import { Helmet } from "react-helmet"

function ONama() {
    return (
        <div className="flex-container full-width flex-grow-1">
          <Helmet>
              <title>Historiografija.ba | O nama</title>
              <meta
                  name="description"
                  content="O nama"
                  data-react-helmet="true" 
              />
          </Helmet>
          <div className="full-width padding-2p static-page-container">
                <h1 className="font-weight-500 text-center">O nama</h1>
                <p>
                  Portal <a href="https://www.historiografija.ba">www.historiografija.ba</a> je nastao 2019. godine, s ciljem da prezentira historiografiju u Bosni i Hercegovini svijetu, kao i približava historiografiju u svijetu Bosni i Hercegovini.
                </p>
                <p>
                  Izdavači historiografske literature mogu najbrže informisati svoje potencijalne čitatelje i kupce o najnovijim izdanjima, a historičari svoje teze i mišljenja mogu najbrže plasirati u akademsku zajednicu i društvenu sredinu.
                </p>
                <br />
                <h2 className="font-weight-400">Naša misija i kvalitet sadržaja</h2>
                <p>
                  Naša misija je pružiti relevantne, tačne i stručne informacije iz oblasti historijskih nauka. Posvećeni smo održavanju visokih standarda akademske stručnosti i profesionalizma.
                </p>
                <p>
                  Svi članci koji se objavljuju na portalu prolaze kroz proces uredničke provjere prije objave. Time osiguravamo da naši posjetioci dobijaju provjeren i visokokvalitetan sadržaj koji doprinosi boljem razumijevanju historiografskih tema.
                </p>
                
          </div>
        </div>
    )
}

export default ONama